<template>
  <el-scrollbar
    ref="scrollContainer"
    :vertical="false"
    class="scroll-container"
    :class="isMiniScreen ? 'mini-window' : ''"
    @wheel.native.prevent="handleScroll"
  >
    <img v-if="isMiniScreen && showLeft" class="leftbtn" src="@/assets/base/leftArrow-grey.png" @click="goScroll('left')" />
    <slot />
    <img v-if="isMiniScreen && showRight" class="rightbtn" src="@/assets/base/rightArrow-grey.png" @click="goScroll('right')" />
  </el-scrollbar>
</template>

<script>
const tagAndTagSpacing = 4 // tagAndTagSpacing

export default {
  name: "ScrollPane",

  data() {
    return {
      left: 0,
      scrollLeft: 0,
      isMiniScreen: false,
      showLeft: true,
      showRight: true
    }
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    }
  },
  mounted() {
    this.scrollWrapper.addEventListener("scroll", this.emitScroll, true)
  },
  beforeDestroy() {
    this.scrollWrapper.removeEventListener("scroll", this.emitScroll)
  },
  methods: {
    handleScroll(e) {
      // const eventDelta = e.wheelDelta || -e.deltaY * 40
      // const $scrollWrapper = this.scrollWrapper
      // $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
    },
    emitScroll() {
      this.$emit("scroll")
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      // if (this.isMiniScreen) {
      //   $containerWidth = $containerWidth - 50
      // }
      const $scrollWrapper = this.scrollWrapper
      const tagList = this.$parent.$refs.tag

      let firstTag = null
      let lastTag = null

      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0]
        lastTag = tagList[tagList.length - 1]
      }

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
      } else {
        // find preTag and nextTag
        const currentIndex = tagList.findIndex(item => item === currentTag)
        const prevTag = tagList[currentIndex - 1]
        const nextTag = tagList[currentIndex + 1]
        // the tag's offsetLeft after of nextTag
        const afterNextTagOffsetLeft = nextTag.offsetLeft + nextTag.offsetWidth + tagAndTagSpacing

        // the tag's offsetLeft before of prevTag
        const beforePrevTagOffsetLeft = prevTag.offsetLeft - tagAndTagSpacing

        if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
          $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
        }
      }
      let tagListAllWidth = 0
      tagList.forEach(item => {
        tagListAllWidth = tagListAllWidth + item.offsetWidth + 12
      })
      // 判断当前新增的标签是否超过容器，形成滚动
      if (tagListAllWidth > $containerWidth) {
        this.isMiniScreen = true
        this.showLeft = true
        this.showRight = true
      } else {
        this.isMiniScreen = false
      }
    },
    restGetWidth() {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      // if (this.isMiniScreen) {
      //   $containerWidth = $containerWidth - 50
      // }
      const tagList = this.$parent.$refs.tag
      let tagListAllWidth = 0
      tagList.forEach(item => {
        tagListAllWidth = tagListAllWidth + item.offsetWidth + 12
      })
      // 判断当前新增的标签是否超过容器，形成滚动
      if (tagListAllWidth > $containerWidth) {
        this.isMiniScreen = true
        this.showLeft = true
        this.showRight = true
      } else {
        this.isMiniScreen = false
      }
    },
    // 点击小屏幕下左右按钮
    goScroll(type) {
      const $container = this.$refs.scrollContainer.$el
      let scrollLeft = this.scrollLeft - 40
      const realNavWidth = $container.scrollWidth
      if (type === "left") {
        scrollLeft = scrollLeft - 1000
        if (scrollLeft < 0) {
          scrollLeft = 0
          // this.showLeft = false
          this.showLeft = true
          this.showRight = true
        } else {
          this.showLeft = true
          this.showRight = true
        }
      } else {
        scrollLeft = scrollLeft + 1000
        if (scrollLeft > realNavWidth) {
          scrollLeft = realNavWidth
          // this.showRight = false
          this.showLeft = true
          this.showRight = true
        } else {
          this.showLeft = true
          this.showRight = true
        }
      }
      this.scrollLeft = scrollLeft
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = scrollLeft
      // this.$refs.scrollContainer.scrollLeft = scrollLeft
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: calc(100% - 10px);
  padding: 0 20px;
  padding-right: 100px;
  ::v-deep {
    .el-scrollbar__bar {
      bottom: -10px;
    }
    .el-scrollbar__wrap {
      scroll-behavior: smooth;
    }
  }
}
.leftbtn {
  position: absolute;
  left: 0px;
  top: 6px;
  //margin-top: -19px;
  cursor: pointer;
  z-index: 9;
  width: 12px;
}
.rightbtn {
  position: absolute;
  right: 80px;
  top: 6px;
  //margin-top: -19px;
  cursor: pointer;
  z-index: 9;
  width: 12px;
}
.mini-window {
  //width: calc(100% - 100px);
}
</style>
